import { render, staticRenderFns } from "./FormularioFirma.vue?vue&type=template&id=4367947d&scoped=true&"
import script from "./FormularioFirma.vue?vue&type=script&lang=js&"
export * from "./FormularioFirma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4367947d",
  null
  
)

export default component.exports